import SuccessView from "../../../common/success";
import FailureView from "../../../common/failure";
import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath, isPlainObject } from "../../../../../utils";
import { chargeCard, chargeSavedCard } from "./init";
import ErrorState from "../../../../common/error";
import PlaceholderView from "../../../common/placeholder";
import SearchParams from "../../../../../init/searchparams";
import handleFailureEvent from "../../../../common/handle_failure_event";

export default function view() {
  const $this = this;
  const { $charge, INIT_VIEW, $inputs, dispatch } = this;

  const resetView = () => {
    const shouldRedirectOnFail = 
      getValueAtPath($this.DATA, 'preferences[should_redirect_on_fail]') === true;

    handleFailureEvent(shouldRedirectOnFail, FailureView, INIT_VIEW, $this);
  }

  const resetSavedCard = () => {
    $inputs.$reset("saved_card");
  }

  const handleError = function() {
    const validationCode = getValueAtPath(this, "validation_code");
    const validationMessage = getValueAtPath(this, "message.validation");
    const isMasterCard = /^5[1-5]/.test(getValueAtPath($inputs, '[card_number].value'));
    const numberOfRetries = SearchParams.get('custom_retry') || null;
    
    if (
        isMasterCard && 
        !(/insufficient/i.test(validationMessage) || validationCode.indexOf("RR") >= 0) &&
        numberOfRetries === null
    ) {
      setTimeout(() => chargeCard.call($this, getValueAtPath(this, "reference.transaction")), 0);
    } else {
        resetView();
  
        const $error = `${
          validationMessage.indexOf('We could not charge this card. Reason') === -1
          ? 'We could not charge this card. Reason: ' : ''
        }${validationMessage}`;
  
        setTimeout(() => dispatch(ErrorState.actions.updateErrorMessage($error)), 100);
    }
  };

  return (view = ViewFactory({
    NAME: 'CARD_OTP_VIEW',
    inputs: ['otp'],
    constants: {
      resendOTP() {
        return ($this.CAN_RESEND_OTP === true)
          ?  PlaceholderView && PlaceholderView.activate(() => ($this.SAVED_CARDS_ACTIVE ? chargeSavedCard : chargeCard).call($this))
          : Promise.resolve(false);
      }
    },
    mutables: { canResendOTP: 'CAN_RESEND_OTP' },
    next() {
      const {
        charge: transaction_reference = null
      } = isPlainObject($this.reference) ? $this.reference : {};

      const otp = getValueAtPath($inputs, '[otp].value');

      if (otp) {
        if ($this.SAVED_CARDS_ACTIVE && $this.useOldSavedCardFlow) {
          const device_key = getValueAtPath($this.$savedCards, 'device.phone');
          const savedCard = getValueAtPath($inputs, '[saved_card].value');
          const card_hash = savedCard.hash;

          $charge.init({
            data: {
              otp,
              card_hash,
              device_key,
              is_visa: savedCard.brand === 'VISA',
              is_saved_card_charge: true,
              include_card_country: true,
              payment_type: 'saved-card'
            },
            onError: resetSavedCard,
            onChargeFailed: resetSavedCard
          });
        } else {
          $charge.validate({
            data: { otp, transaction_reference },
            onError: resetView,
            onValidateFailed: handleError,
            onValidateSuccessful() { SuccessView && SuccessView.activate.call($this) },
            onComplete() { /* self.console.log({ ...$this }) */ $this.clearResendTimer() }
          });
        }
      }
    }
  }).call(this));
}
